import './MetadataContainer.scss';
import classNames from 'classnames';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { Descriptions } from 'antd';
import { DetailSection } from '../DetailSection';
import { isBoolean } from '@sonar-software/sonar-ts-lib';
import React from 'react';
function getArrayValueRow(entry, index) {
    const displayEntry = `${index + 1}: ${entry}`;
    return (React.createElement("div", { key: entry },
        displayEntry,
        React.createElement("br", null)));
}
function getValue(value, type) {
    var _a;
    switch (type) {
        case 'boolean':
            const isValid = isBoolean(value);
            if (!isValid) {
                return '';
            }
            return value ? COPY_SPECIFIC.YES : COPY_SPECIFIC.NO;
        case 'string':
            return (_a = (value !== null && value !== void 0 ? value : '').toString()) === null || _a === void 0 ? void 0 : _a.trim();
        case 'array':
            if (!value) {
                return '';
            }
            const valueArray = value;
            return React.createElement("div", null, valueArray.map((entry, index) => getArrayValueRow(entry, index)));
        default:
            return '';
    }
}
function determineClassName(metadataEntry) {
    return classNames({ title: metadataEntry.bold });
}
export const MetadataContainer = ({ entries, title }) => {
    if (!entries.length) {
        return null;
    }
    return (React.createElement(DetailSection, { className: 'periscope-metadata-wrapper', title: title },
        React.createElement(Descriptions, { bordered: true, column: 1, size: 'small' }, entries.map((entry) => React.createElement(Descriptions.Item, { className: determineClassName(entry), key: entry.label, label: entry.label }, getValue(entry.value, entry.type))))));
};
